import { useSeo } from "../hooks/useSeo";
import Hero from "../components/Hero";
import Philosophy from "../components/Philosophy";
import Origins from "../components/Origins";
import ProductGrid from "../components/ProductGrid";
import Quiz from "../components/Quiz";
import Testimonials from "../components/Testimonials";
import BlogTeaser from "../components/BlogTeaser";

export default function Home() {
  useSeo({
    title: "Prémium póthaj – festetlen európai és kazahsztáni haj | Hair Elixir Hungary",
    description: "Prémium, festetlen európai és kazahsztáni emberi póthaj hajhosszabbításhoz. Egyenes, hullámos és göndör hajcopfok, több hosszban és tömegben.",
    path: "/",
  });
  return (
    <main data-testid="page-home">
      <Hero />
      <Philosophy />
      <Origins />
      <ProductGrid compact />
      <Quiz embedded />
      <Testimonials />
      <BlogTeaser />
    </main>
  );
}
